/** @format */

import {
	homefieldIconBrandingDsgMono,
	homefieldIconChainLink,
	HomefieldIconLibraryModule,
	homefieldIconNikeLogo,
	homefieldIconNikeMember,
	homefieldIconNikeShoe,
	homefieldIconRewards,
	HomefieldIconsLibraryService
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { HtmlSanitizerPipe } from '@shared/utils/pipes';
import { ExclusiveProductPanelComponent } from './exclusive-product-panel.component';
import {
	HmfAlertBannerComponent,
	HmfButtonComponent,
	HmfSidePanelComponent
} from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';
import { StickyBannerComponent } from '../sticky-banner/sticky-banner.component';

@NgModule({
	declarations: [ExclusiveProductPanelComponent],
	imports: [
		CommonModule,
		HmfAlertBannerComponent,
		HmfButtonComponent,
		HmfSidePanelComponent,
		HomefieldIconLibraryModule,
		HtmlSanitizerPipe,
		StickyBannerComponent
	],
	exports: [ExclusiveProductPanelComponent]
})
export class ExclusiveProductPanelModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconNikeLogo,
			homefieldIconBrandingDsgMono,
			homefieldIconChainLink,
			homefieldIconNikeShoe,
			homefieldIconNikeMember,
			homefieldIconRewards
		]);
	}
}
